var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("studip-dialog", {
    attrs: {
      height: "430",
      width: "600",
      title: _vm.$gettext("Feedback"),
      confirmText: _vm.$gettext("Feedback abgeben"),
      confirmClass: "accept",
      closeText: _vm.$gettext("Schließen"),
      closeClass: "cancel",
    },
    on: {
      close: function close($event) {
        return _vm.$emit("close")
      },
      confirm: _vm.submitEntry,
    },
    scopedSlots: _vm._u([
      {
        key: "dialogContent",
        fn: function fn() {
          return [
            _c("h2", [
              _vm._v(
                _vm._s(
                  _vm.$gettextInterpolate(
                    _vm.$gettext("Bewertung für %{title}"),
                    {
                      title: _vm.structuralElement.attributes.title,
                    }
                  )
                )
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "feedback-entry-create",
              },
              [
                _c("studip-five-stars-input", {
                  model: {
                    value: _vm.rating,
                    callback: function callback($$v) {
                      _vm.rating = $$v
                    },
                    expression: "rating",
                  },
                }),
                _vm._v(" "),
                _vm.isCommentable
                  ? _c("label", [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$gettext("Kommentar")) +
                          "\n                "
                      ),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.comment,
                            expression: "comment",
                          },
                        ],
                        domProps: {
                          value: _vm.comment,
                        },
                        on: {
                          input: function input($event) {
                            if ($event.target.composing) return
                            _vm.comment = $event.target.value
                          },
                        },
                      }),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.anonymousEntriesEnabled
                  ? _c("label", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.anonymous,
                            expression: "anonymous",
                          },
                        ],
                        attrs: {
                          type: "checkbox",
                        },
                        domProps: {
                          checked: Array.isArray(_vm.anonymous)
                            ? _vm._i(_vm.anonymous, null) > -1
                            : _vm.anonymous,
                        },
                        on: {
                          change: function change($event) {
                            var $$a = _vm.anonymous,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.anonymous = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.anonymous = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.anonymous = $$c
                            }
                          },
                        },
                      }),
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$gettext("Feedback anonym abgeben")) +
                          "\n            "
                      ),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }